<style lang="scss" scoped>
.detail-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .item {
    width: 45%;
  }
}
.detais {
  li {
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
    font-size: 12px;
    color: #666;
    .label {
      width: 75px;
      text-align: right;
    }
    .content {
      flex: 1;
    }
    &.red {
      color: red;
    }
    &.blue {
      color: #409eff;
    }
  }
}
</style>
<template>
  <div>
    <ul class="detais">
      <li :class="colorStyle('total_money')">
        <span class="label">总额度：</span>
        <span class="content">{{ data.total_money }}元</span>
      </li>
      <li :class="colorStyle('money_type')">
        <span class="label">红包类型：</span>
        <span class="content">{{ data.money_type === 'random' ? '随机金额' : '固定金额' }} </span>
      </li>
      <li :class="colorStyle('money_type')">
        <span class="label">红包额度：</span>
        <span
          v-if="data.money_type === 'random'"
          class="content"
        >{{ data.min_money }} ~ {{ data.max_money }} 元</span>
        <span
          v-if="data.money_type === 'fixed'"
          class="content"
        >{{ data.min_money }} 元</span>
      </li>
      <li :class="colorStyle('end_time')">
        <span class="label">活动时间段：</span>
        <span class="content">{{ data.begin_time }} 至 {{ data.end_time }}</span>
      </li>
      <li :class="colorStyle('send_type')">
        <span class="label">发放类型：</span>
        <span class="content">
          <template v-if="data.send_type === 'at_once'">立即发放</template>
          <template v-if="data.send_type === 'delay'">延时发放</template>
          <template v-if="data.send_type === 'timing'">定时发放</template>
        </span>
      </li>
      <li
        v-if="data.send_type === 'delay'"
        :class="colorStyle('send_type')"
      >
        <span class="label">延时时间：</span>
        <span class="content">
          <template
            v-if="data.send_type === 'delay'"
          >{{ data.day }}天 {{ data.hour }}时 {{ data.min }}分</template>
        </span>
      </li>
      <li
        v-if="data.send_type === 'timing'"
        :class="colorStyle('due_time')"
      >
        <span class="label">发放时间：</span>
        <span class="content">
          <template v-if="data.send_type === 'timing'">{{ data.due_time }}</template>
        </span>
      </li>
      <li :class="colorStyle('is_active')">
        <span class="label">是否开启：</span>
        <span class="content">{{ data.is_active === true ? '开启' : '关闭' }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ['data', 'changes'],
  data () {
    return {
      key: 1,
      detailData: {},
      itemChange: []
    }
  },
  computed: {},
  watch: {
    data (newVal, oldVal) {
      console.log(newVal)
    },
    changes (newVal, oldVal) {
      console.log(newVal)
    }
  },
  mounted () {
    //this.detailData = this.data
    //this.itemChange = this.changes
  },
  created () {},
  methods: {
    colorStyle (val) {
      const changes = Array.from(this.changes)
      if (changes.includes(val)) {
        return this.data.type === 'prev' ? 'red' : 'blue'
      }
    }
  }
}
</script>
